import React from "react";
import * as classes from "./flowStepContainer.module.scss";
import classNames from "classnames";
import { Helmet } from "react-helmet";

export default function FlowStepContainer({
  stepNo,
  totalSteps,
  overrideStepLabel,
  noStepLabel,
  title,
  subTitle,
  outerCtnClass,
  innerCtnClass,
  stepLabelClass,
  style,
  children,
  forTrial,
}) {
  let stepLabel;
  if (overrideStepLabel) {
    stepLabel = overrideStepLabel;
  } else {
    stepLabel = `Step ${stepNo} of ${totalSteps}`;
  }

  return (
    <div className={classNames(classes.container, outerCtnClass, { [classes.trial]: forTrial })} style={style}>
      <Helmet bodyAttributes={{ class: classes.body }} />
      <div className={classNames(classes.inner, innerCtnClass)}>
        {!noStepLabel && <p className={classNames(classes.label, stepLabelClass, "eyebrow")}>{stepLabel}</p>}
        <div className={classes.titleContainer}>
          {title && <h4 className={classNames(classes.title, "h4")}>{title}</h4>}
          {subTitle && <p className={classNames(classes.subtitle, "p3")}>{subTitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}
